import { setFooterTab } from '@/redux/features/filterSlice'
import Image from 'next/image'
import React from 'react'
import { useDispatch } from 'react-redux'
import CatalogCategory from '../catalog/CatalogCategory'
import MainAboutCard from '../main/MainAboutCard'
import CatalogCategoriesSlider from '../catalog/CatalogCategoriesSlider'
import { useTranslation } from 'react-i18next'

export const featuresList = [
    {
        id: '1',
        title: 'Первые в России и мире',
        image_url: '/assets/img/about-us/vitamin/frame-1.png',
        bottomLine: 'Инновит Е60',
        description: 'Первый сухой кормовой витамин Е, произведенный в России'
    },
    {
        id: '2',
        title: 'Современное производство',
        image_url: '/assets/img/about-us/vitamin/frame-2.png',
        bottomLine: 'Инновит Е60',
        description: 'Производство на современном заводе в Липецкой области'
    },
    {
        id: '3',
        title: 'Удобная форма применения',
        image_url: '/assets/img/about-us/vitamin/frame-3.png',
        bottomLine: 'Инновит Е60',
        description: 'Форма выпуска — порошок'
    },
    {
        id: '4',
        title: 'Инновационная технология',
        image_url: '/assets/img/about-us/vitamin/frame-4.png',
        bottomLine: 'Инновит Е60',
        description: 'Инновационный витамин Е с долей активного вещества 60%. Не имеет аналогов в мире'
    }
]

interface IProps {
    btnContent: string
    item: {
        tag: string
        title: string
        text: string[]
    }
}

export const AboutUsVitamin: React.FC<IProps> = ({ btnContent, item }) => {
    const dispatch = useDispatch()
    const {t} = useTranslation()

    const featuresListInner = [
        {
            id: '1',
            title: t('First_in_Russia_and_the_world'),
            image_url: '/assets/img/about-us/vitamin/frame-1.png',
            bottomLine: t('Innovit_E60'),
            description: t('First_dry_feed_vitamin_E_produced')
        },
        {
            id: '2',
            title: t('Modern_production'),
            image_url: '/assets/img/about-us/vitamin/frame-2.png',
            bottomLine: t('Innovit_E60'),
            description: t('Production_at_a_modern_plant')
        },
        {
            id: '3',
            title: t('Convenient_of_application'),
            image_url: '/assets/img/about-us/vitamin/frame-3.png',
            bottomLine: t('Innovit_E60'),
            description: t('Form_release_powder')
        },
        {
            id: '4',
            title: t('Innovative_technology'),
            image_url: '/assets/img/about-us/vitamin/frame-4.png',
            bottomLine: t('Innovit_E60'),
            description: t('Innovative_vitamin_E_with_a_fraction')
        }
    ]

    const scrollToChapter = chapterId => {
        const element = document.getElementById(chapterId)

        dispatch(setFooterTab(3))

        if (element) {
            element.scrollIntoView({ behavior: 'smooth' })
        }
    }

    return (
        <div className='main__order about-us__vitamin'>
            <div className='main-about__card-content about-us__vitamin-left'>
                <MainAboutCard
                    item={item}
                    image={
                        <div className='about-us__vitamin-card-pie'>
                            <Image
                                quality={100}
                                src={'/assets/img/about-us/pie-chart.png'}
                                width={544}
                                height={258}
                                alt='Image'
                            />
                        </div>
                    }
                />
                <div className='main-about__card-buttons'>
                    <button
                        onClick={() => scrollToChapter('contact')}
                        className='main__order-button main__card-button'
                    >
                        <svg
                            width='21'
                            height='16'
                            viewBox='0 0 21 16'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                        >
                            <path
                                d='M1.5 13.1059V3C1.5 1.89543 2.39543 1 3.5 1H17.5C18.6046 1 19.5 1.89543 19.5 3V13.1059C19.5 14.2104 18.6046 15.1059 17.5 15.1059H3.5C2.39543 15.1059 1.5 14.2104 1.5 13.1059Z'
                                stroke='#83A3EB'
                                strokeWidth='1.6'
                            />
                            <path
                                d='M1.5 3.5L10.3829 9.91543C10.4528 9.96591 10.5472 9.96591 10.6171 9.91543L19.5 3.5'
                                stroke='#83A3EB'
                                strokeWidth='1.6'
                            />
                        </svg>
                        <p>{btnContent}</p>
                    </button>
                </div>
            </div>
            <div className='about-us__vitamin-list'>
                <ul
                    className='useful-materials__block container'
                >
                    {featuresListInner.map(item => (
                        <CatalogCategory
                            key={item.id}
                            item={item}
                            classItem={'labs__features-card'}
                            type={'labs'}
                        />
                    ))}
                </ul>
            </div>
            <div style={{ padding: 0 }} className="container">
                <CatalogCategoriesSlider list={featuresList} type='b2b' />
            </div>
        </div>
    )
}
